/**
 * 授权工具utils
 * 1、授权专注通用逻辑，其他都放这里处理
 * 2、处理各个端的文件引用方式不同
 * 3、为后期授权稳定后抽出来做准备
 */

import md5 from 'md5';
import cookies from '@/utils/cookie';
import Utils from '@/utils/utils';
import wechatApi from '@/api/wechat';
import readerCenterApi from '@/api/readercenter';
import channelCenterApi from '@/api/channelcenter';
import * as config from '@/config';
import Locator from '@/utils/locator';

const authUtils = {
  CONSTANT: {
    LOCAL_CODE: 'LOCAL_CODE',
    AUTHORIZE_TIME: 'AUTHORIZE_TIMING_20190508',
    AUTHORIZE_DURATION: 30 * 1000, //30s内的授权code记为有效
    USER_TYPE_REGULAR: 'REGULAR', //真实授权用户类型
    USER_TYPE_TEMP: 'TEMP' //临时localCode换取的用户类型
  },
  saveLocalCode() {
    if(!authUtils.getLocalCode()) {
      let code = md5(`${
        window.navigator.userAgent
      }${Math.random()}${Math.random()}${Date.now()}`);
      window.localStorage.setItem(authUtils.CONSTANT.LOCAL_CODE, code);
    }
  },
  getLocalCode() {
    let localCode = window.localStorage.getItem(authUtils.CONSTANT.LOCAL_CODE);
    if(localCode && `${localCode}`.length === 32) {
      return localCode;
    }
    return '';
  },
  saveStartAuthTime() {
    window.localStorage.setItem(
      authUtils.CONSTANT.AUTHORIZE_TIME,
      JSON.stringify(new Date().getTime())
    );
  },
  // 检查从发起授权开始到授权回来时间是否符合要求
  checkAuthorizeTime() {
    const times = parseInt(window.localStorage.getItem(authUtils.CONSTANT.AUTHORIZE_TIME));
    if(times) {
      return (
        new Date().getTime() - times < authUtils.CONSTANT.AUTHORIZE_DURATION
      );
    } else {
      return false;
    }
  },
  removeLocalAuthTime() {
    window.localStorage.removeItem(authUtils.CONSTANT.AUTHORIZE_TIME);
  },
  saveCookieUser(json) {
    const { adviserId } = Locator.query || {};
    const userInfoCookie = {
      officialAccountsId: json.officialAccountsId,
      wechatUserId: json.wechatUserId,
      partyId: json.partyId,
      userCode: json.userCode,
      mainUserId: json.mainUserId,
      payCode: json.payCode,
      hasSnapsis: json.nickName ? 1 : 0,
      nickName: json.nickName,
      userType: json.userType || authUtils.CONSTANT.USER_TYPE_REGULAR,
      adviserId
    };
    return cookies.setItem(userInfoCookie);
  },
  getUserType() {
    // userType
    const userMap = {
      [authUtils.CONSTANT.USER_TYPE_TEMP]: 1,
      [authUtils.CONSTANT.USER_TYPE_REGULAR]: 2
    };
    const { userType } = cookies.get();
    return userMap[userType];
  },

  getCookieUser() {
    const userInfo = cookies.get();
    return Object.assign({}, userInfo, {
      isTempUser: userInfo.userType === authUtils.CONSTANT.USER_TYPE_TEMP
    });
  },
  removeCookieUser() {
    // cookies.remove(); 无法清除 ？？？
    document.cookie =
      'userInfo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    cookies.remove();
  },
  createTempUser: async () => {
    let data = await wechatApi.getTempUserByLocalCode({
      localCode: authUtils.getLocalCode()
    });
    //存储临时信息
    authUtils.saveCookieUser(Object.assign(data, {
      userType: authUtils.CONSTANT.USER_TYPE_TEMP
    }));
  },
  getUrlQuery() {
    return Utils.params2json(`${window.location.search}`.slice(1), '&');
  },
  browser: Utils.browser,
  json2params: Utils.json2params,
  params2json: Utils.params2json,
  padQuery: Utils.padQuery,
  config: config,
  wechatApi,
  readerCenterApi,
  channelCenterApi
};

export default authUtils;
